import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RequestBoxSendComponent } from './requestBoxSend.component';
import { RequestBoxSendRoutingModule } from './requestBoxSend-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from "ng-select";
import { BsDatepickerModule, ModalModule, TooltipModule } from 'ngx-bootstrap';
import { BoxRetalStampsModule } from '../share/boxRetalStamps/boxRetalStamps.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    RequestBoxSendRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    BsDatepickerModule.forRoot(),
    TooltipModule,
    BoxRetalStampsModule,
    ModalModule,
    TranslateModule,

  ],
  declarations: [RequestBoxSendComponent]
})
export class RequestBoxSendModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/requestBoxSend/requestBoxSend.module.ts